export const SETTING_TITLE = 'SETTING_TITLE';
export const SETTING_LOGO = 'SETTING_LOGO';
export const SETTING_FAVICON = 'SETTING_FAVICON';
